/* =============================================================================
=    Query User
============================================================================= */
// import { gql } from 'generated-types/gql';
import gql from 'graphql-tag';

export default gql`
  query referrer($referralCode: String!) {
      referrer(referralCode: $referralCode){
          name,
          avatar,
          avatarUrl,
      }
}
`;
